export default {
  startDate: {
    id: 'bo_sellers-orders-components-filters-start_date',
    defaultMessage: 'Start date',
  },
  endDate: {
    id: 'bo_sellers-orders-components-filters-end_date',
    defaultMessage: 'End date',
  },
  encoding: {
    id: 'bo_sellers-orders-drawers-export_csv_file-fields_encoding_label',
    defaultMessage: 'Encoding',
  },
  state: {
    id: 'bo_sellers-orders-components-filters-order_state',
    defaultMessage: 'Order state',
  },
  isBackship: {
    id: 'bo_sellers-orders-components-filters-backship',
    defaultMessage: 'BackShip',
  },
  orderId: {
    id: 'bo_sellers-orders-components-filters-order_id',
    defaultMessage: 'Order Id',
  },
  sku: {
    id: 'bo_sellers-orders-components-filters-sku',
    defaultMessage: 'SKU',
  },
  customerFirstName: {
    id: 'bo_sellers-orders-components-filters-customer_first_name',
    defaultMessage: 'Customer first name',
  },
  customerLastName: {
    id: 'bo_sellers-orders-components-filters-customer_last_name',
    defaultMessage: 'Customer last name',
  },
  market: {
    id: 'bo_sellers-orders-components-filters-market',
    defaultMessage: 'Country',
  },
  carrierId: {
    id: 'bo_sellers-orders-components-filters-shipping-provider',
    defaultMessage: 'Shipping provider',
  },
  dateType: {
    id: 'bo_sellers-orders-components-filters-date_type',
    defaultMessage: 'Date type',
  },
  required: {
    id: 'bo_sellers-orders-components-filters-required',
    defaultMessage: 'This field is required',
  },
} as const
